import Primary from "./Primary";
import Secondary from "./Secondary";
import Ghost from "./Ghost";
import Alert from "./Alert";
import Icon from "./Icon";

const Button = { Primary, Secondary, Ghost, Alert, Icon };

export default Button;
